// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"656":"5a251363","716":"8951259c","720":"39db0d41","927":"6cc2ce4f","954":"59c489b3"}[chunkId] + ".chunk.js";
};